module.exports = __webpack_public_path__ + "media/images/ic-index-suspicious-7bbe3b3901d32dce6703bcf571cf51bf.svg";